import React, { useState, useRef } from 'react';
import { Grid, Theme, Button, Tab, AppBar, alpha } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';

import UserTestimonialsSlider from '../UserTestimonialsSlider';

const testimonialsData = [
  {
    text: 'English is my second language and the Quillbot made me feel confident in expressing my ideas. thank you!',
    name: 'Alison',
    mode: 'Contact Form',
  },
  {
    text: 'Heeeeeey Guys, You are the best Paraphrasing tool in the whole world. Thank You for being SOOOOOO perfect',
    name: 'Jasmin',
    mode: 'Feedback Form',
  },
  {
    text: 'Quillbot is a life saving tool,it is the gear that has made my writing appear more modern, and even more youthful',
    name: 'Masoud',
    mode: 'Contact Form',
  },
  {
    text: 'I love you guys. That’s it. I just wanted to say, I love you guys. Thanks for making QuillBot awesome',
    name: 'Alex',
    mode: 'Contact Form',
  },
  {
    text: 'You are the key to my academic success, can’t imagine life without quillbot',
    name: 'Han',
    mode: 'Feedback Form',
  },
  {
    text: 'I find this software to be a superior productivity tool. It saves me tons of time and headaches!',
    name: 'Bridget',
    mode: 'Contact Form',
  },
  {
    text: 'Quillbot has made my work a lot easier.It’s really nice and helpful while writing research articles.',
    name: 'Vikas',
    mode: 'Contact Form',
  },
  {
    text: 'I just want to say that I love quillbot so much, this website is pure bliss and I mean this with all my heart.',
    name: 'Meera',
    mode: 'Contact Form',
  },
];

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 1142,
    margin: '0 auto',
    padding: '64px 16px',
  },
  heroTextWrapper: {
    margin: '0 auto',
    textAlign: 'center',
  },
  pageTitle: {
    maxWidth: 640,
    margin: '0 auto',
    fontSize: 30,
    fontWeight: 400,
    textAlign: 'center',
  },
  heroSubtext: {
    maxWidth: 528,
    margin: '24px auto 32px',
    fontSize: 16,
    color: theme.specialColors.ICON_DEFAULT_COLOR,
  },
  testimonialsWrapper: {},
}));

export default function Testimonials() {
  const classes = useStyles();

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <div className={classes.heroTextWrapper}>
            <h2 className={classes.pageTitle}>
              Students all over the world are becoming better writers with QuillBot.
            </h2>
            <div className={classes.heroSubtext}>
              Every hour, more than 2,000 students join the QuillBot platform!
            </div>
          </div>
          <div className={classes.testimonialsWrapper}>
            <UserTestimonialsSlider data={testimonialsData} />
          </div>
        </Grid>
      </Grid>
    </>
  );
}
